import { render, staticRenderFns } from "./ModalAddShop.vue?vue&type=template&id=401f22cf&"
import script from "./ModalAddShop.vue?vue&type=script&lang=js&"
export * from "./ModalAddShop.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddShop.vue?vue&type=style&index=0&id=401f22cf&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports